import { render, staticRenderFns } from "./DiscoverItem.vue?vue&type=template&id=da0ae978&scoped=true&"
import script from "./DiscoverItem.vue?vue&type=script&lang=js&"
export * from "./DiscoverItem.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverItem.vue?vue&type=style&index=0&id=da0ae978&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0ae978",
  null
  
)

export default component.exports